import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'motion/react';
import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
const variants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    hide: { opacity: 0 },
};
export const RotatingElements = ({ children, rotationSpeed = 3 }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [ref, inView] = useInView({ threshold: 0.5 });
    const items = React.Children.toArray(children).filter(Boolean);
    useEffect(() => {
        if (!inView || items.length <= 1)
            return;
        const timeout = setTimeout(() => {
            setActiveIndex((i) => (i + 1) % items.length);
        }, rotationSpeed * 1000);
        return () => clearTimeout(timeout);
    }, [inView, activeIndex, items.length, rotationSpeed]);
    return (_jsx("ul", { ref: ref, className: "relative m-0 grid list-none grid-cols-1 p-0", children: items.map((child, i) => (_jsx(motion.li, { className: "relative col-1 row-1", variants: variants, initial: "initial", animate: activeIndex === i ? 'animate' : 'hide', children: child }, i))) }));
};
